import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  payrollSettings: {},
  accountingSettings: {},
  loading: false,
};

const settingsReducer = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setPayrollSettingsData: (state, action) => {
      return {
        ...state,
        payrollSettings: action.payload
      }
    },
    setAccountingSettingsData: (state, action) => {
      return {
        ...state,
        accountingSettings: action.payload
      }
    },
    setLoadingData: (state, action) => {
      return {
        ...state,
        loading: action.payload, // Update the loading state
      };
    },
  },
});

export const {
  setPayrollSettingsData,
  setAccountingSettingsData,
  setLoadingData
} = settingsReducer.actions;

export default settingsReducer.reducer;